<script setup>
import AuthorsTable from "./components/AuthorsTable.vue";
import ProjectsTable from "./components/ProjectsTable.vue";
import {CheckUser} from "@/assets/js/Help";
///////////////////////Access Check///////////////////////
import {onBeforeMount} from "vue";
import {useStore} from "vuex";
const store = useStore();
import {useRouter} from "vue-router";
const router = useRouter();
const updateAdmin = (payload) => {
  store.dispatch("updateCurrAdmin", payload);
};
onBeforeMount(async () => {
  const data = await CheckUser(router)
  await updateAdmin(data)
});
///////////////////////Access Check END////////////////////
</script>
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <authors-table />
      </div>
    </div>
    <div class="mt-4 row">
      <div class="col-12">
        <projects-table />
      </div>
    </div>
  </div>
</template>
